import { discardAccessibilityOption } from '../actions/internalActions';
import { mutator } from 'satcheljs';
import getPreferAccessibleContentOption from '../../selectors/getPreferAccessibleContentOption';
import store from '../store/store';

/**
 * Mutator to discard the changes
 */
export default mutator(discardAccessibilityOption, () => {
    store().isEnabled = getPreferAccessibleContentOption();
});
